import { render, staticRenderFns } from "./BuyerCampaignsList.vue?vue&type=template&id=0a068645&scoped=true"
import script from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
import style0 from "./BuyerCampaignsList.vue?vue&type=style&index=0&id=0a068645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a068645",
  null
  
)

export default component.exports